/* Norlaya Home — interactions
   Header scroll state · reveal on scroll · rails · quick add · wishlist */
(function () {
  'use strict';

  var doc = document;
  var root = doc.documentElement;

  /* ---------------------------------------------------------------
     1. Header: measure height, toggle solid/transparent on scroll
     --------------------------------------------------------------- */
  function headerEl() {
    return doc.querySelector('.header') ||
           doc.querySelector('.shopify-section-group-header-group');
  }

  /* The header group is several sticky siblings (announcement bar, header…).
     The hero should slide under the *header* but stay below the announcement
     bar, so we measure where the announcement bar ends and pull from there. */
  function measureHeader() {
    var groups = [].slice.call(doc.querySelectorAll('.shopify-section-group-header-group'));
    var total = 0;
    groups.forEach(function (g) { total += g.getBoundingClientRect().height; });
    if (total > 0) root.style.setProperty('--lh-header-h', Math.round(total) + 'px');

    var hero = doc.querySelector('.lh-hero');
    if (!hero || window.scrollY > 4) return;

    var announce = null;
    groups.forEach(function (g) {
      if (!announce && g.querySelector('.announcement-bar, [class*="announcement"]')) announce = g;
    });
    var announceH = announce ? announce.getBoundingClientRect().height : 0;
    root.style.setProperty('--lh-announce-h', Math.round(announceH) + 'px');
    var stopAt = announce
      ? announce.getBoundingClientRect().bottom + window.scrollY
      : 0;

    // Neutralise the pull on the element that actually carries it, otherwise
    // the next measurement reads the already-shifted position and collapses to 0.
    var sec = hero.closest('.shopify-section') || hero;
    var saved = hero.style.marginTop;
    hero.style.marginTop = '0px';
    var natural = sec.getBoundingClientRect().top + window.scrollY;
    hero.style.marginTop = saved;

    var pull = Math.max(0, Math.round(natural - stopAt));
    root.style.setProperty('--lh-hero-pull', pull + 'px');
  }

  // Layout settles late (webfonts, logo image, announcement bar) — keep watching.
  function watchHeader() {
    measureHeader();
    window.addEventListener('load', measureHeader);
    if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(measureHeader);
    [100, 350, 900, 1800].forEach(function (t) { setTimeout(measureHeader, t); });
    var h = headerEl();
    if (h && 'ResizeObserver' in window) {
      new ResizeObserver(measureHeader).observe(h);
    }
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      doc.body.classList.toggle('lh-scrolled', window.scrollY > 40);
      ticking = false;
    });
  }

  /* ---------------------------------------------------------------
     2. Reveal on scroll
     --------------------------------------------------------------- */
  /* ---------------------------------------------------------------
     Unwrap: the theme puts custom-liquid inside
     .section-spacing > .container > .text-center, which centres the
     text and caps the width. Strip those on our own sections only.
     --------------------------------------------------------------- */
  var HOST_KILL = ['text-center', 'container', 'section-spacing', 'bordered-section'];

  function normaliseHosts() {
    doc.querySelectorAll('.lh-hero, .lh-sec, .lh-edito, .lh-usp, .lh-wh, .lh-colhero').forEach(function (root) {
      var sec = root.closest('.shopify-section');
      if (!sec) return;
      sec.classList.add('lh-host');
      var node = root.parentElement;
      while (node && node !== sec) {
        HOST_KILL.forEach(function (c) { node.classList.remove(c); });
        node = node.parentElement;
      }
    });
  }

  function revealAll() {
    doc.querySelectorAll('.lh-rev-up, .lh-mask').forEach(function (el) {
      el.classList.add('is-in');
    });
  }

  function initReveal() {
    var items = doc.querySelectorAll('.lh-rev-up:not(.is-in), .lh-mask:not(.is-in)');
    if (!items.length) return;

    if (!('IntersectionObserver' in window)) { revealAll(); return; }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    items.forEach(function (el) { io.observe(el); });

    // Safety net: never leave content stuck at opacity 0.
    clearTimeout(initReveal._t);
    initReveal._t = setTimeout(function () {
      doc.querySelectorAll('.lh-rev-up:not(.is-in), .lh-mask:not(.is-in)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-in');
      });
    }, 2500);
  }

  /* ---------------------------------------------------------------
     3. Horizontal rails (category / carousel)
     --------------------------------------------------------------- */
  function initRails() {
    doc.querySelectorAll('[data-lh-rail]').forEach(function (wrap) {
      var rail = wrap.querySelector('.lh-rail');
      var prev = wrap.querySelector('[data-rail-prev]');
      var next = wrap.querySelector('[data-rail-next]');
      if (!rail) return;

      function step() {
        var first = rail.firstElementChild;
        if (!first) return rail.clientWidth * 0.8;
        var gap = parseFloat(getComputedStyle(rail).columnGap || '20') || 20;
        return first.getBoundingClientRect().width + gap;
      }
      function sync() {
        if (!prev || !next) return;
        var max = rail.scrollWidth - rail.clientWidth - 2;
        prev.disabled = rail.scrollLeft <= 2;
        next.disabled = rail.scrollLeft >= max;
      }
      if (prev) prev.addEventListener('click', function () {
        rail.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      if (next) next.addEventListener('click', function () {
        rail.scrollBy({ left: step(), behavior: 'smooth' });
      });
      rail.addEventListener('scroll', function () {
        requestAnimationFrame(sync);
      }, { passive: true });
      sync();
    });
  }

  /* ---------------------------------------------------------------
     4. Quick add to cart
     --------------------------------------------------------------- */
  function openCart() {
    // try the theme's drawer, otherwise fall back to /cart
    var drawer = doc.querySelector('cart-drawer, #cart-drawer, .drawer--cart');
    if (drawer && typeof drawer.open === 'function') { drawer.open(); return true; }
    var trigger = doc.querySelector('[data-action="open-drawer"][aria-controls*="cart"], a[href="/cart"]');
    if (drawer && trigger) { trigger.click(); return true; }
    return false;
  }

  function initQuickAdd() {
    doc.addEventListener('click', function (ev) {
      var btn = ev.target.closest('[data-lh-add]');
      if (!btn) return;
      ev.preventDefault();
      var id = btn.getAttribute('data-lh-add');
      if (!id || btn.disabled) return;

      var label = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
        .then(function () {
          btn.textContent = 'Added ✓';
          doc.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          setTimeout(function () {
            btn.textContent = label;
            btn.disabled = false;
            if (!openCart()) window.location.href = '/cart';
          }, 850);
        })
        .catch(function () {
          btn.textContent = 'Unavailable';
          setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1600);
        });
    });
  }

  /* ---------------------------------------------------------------
     5. Wishlist (localStorage)
     --------------------------------------------------------------- */
  var WKEY = 'lh_wishlist';
  function wishGet() {
    try { return JSON.parse(localStorage.getItem(WKEY) || '[]'); } catch (e) { return []; }
  }
  function wishSet(list) {
    try { localStorage.setItem(WKEY, JSON.stringify(list)); } catch (e) {}
  }
  function initWishlist() {
    var list = wishGet();
    doc.querySelectorAll('[data-lh-wish]').forEach(function (b) {
      if (list.indexOf(b.getAttribute('data-lh-wish')) > -1) b.classList.add('is-on');
    });
    doc.addEventListener('click', function (ev) {
      var b = ev.target.closest('[data-lh-wish]');
      if (!b) return;
      ev.preventDefault();
      var handle = b.getAttribute('data-lh-wish');
      var cur = wishGet();
      var i = cur.indexOf(handle);
      if (i > -1) { cur.splice(i, 1); b.classList.remove('is-on'); }
      else { cur.push(handle); b.classList.add('is-on'); }
      wishSet(cur);
    });
  }


  /* ---------------------------------------------------------------
     6. Free-delivery progress in the cart drawer
     --------------------------------------------------------------- */
  var FREE_THRESHOLD = 10000;   // in cents — £100 / €100

  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
    var sym = cur === 'EUR' ? '\u20AC' : cur === 'USD' ? '$' : '\u00A3';
    return sym + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function renderFreeship(total) {
    var host = doc.querySelector('cart-drawer .drawer__content, cart-drawer form, #cart-drawer .drawer__content');
    if (!host) return;

    var box = host.querySelector('.lh-freeship');
    if (!box) {
      box = doc.createElement('div');
      box.className = 'lh-freeship';
      host.insertBefore(box, host.firstChild);
    }
    var left = FREE_THRESHOLD - total;
    var pct = Math.max(0, Math.min(100, (total / FREE_THRESHOLD) * 100));
    box.innerHTML = left > 0
      ? 'You are <b>' + money(left) + '</b> away from free UK delivery.' +
        '<span class="lh-freeship__bar"><span style="width:' + pct + '%"></span></span>'
      : '<b>Free UK delivery unlocked.</b>' +
        '<span class="lh-freeship__bar"><span style="width:100%"></span></span>';
  }

  function refreshCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
      .then(function (c) { renderFreeship(c.total_price || 0); })
      .catch(function () { /* cart unavailable — leave the drawer untouched */ });
  }

  function initCart() {
    refreshCart();
    doc.addEventListener('cart:refresh', refreshCart);
    doc.addEventListener('cart:change', refreshCart);
    // the drawer is injected late, so watch for it
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(function () {
        if (doc.querySelector('cart-drawer, #cart-drawer')) refreshCart();
      });
      mo.observe(doc.body, { childList: true, subtree: true });
    }
  }

  /* ---------------------------------------------------------------
     Boot
     --------------------------------------------------------------- */
  function boot() {
    doc.body.classList.add('lh2');
    root.classList.add('lh-anim');   // enables the hidden-then-reveal styles
    normaliseHosts();
    watchHeader();
    onScroll();
    initReveal();
    initRails();
    initQuickAdd();
    initWishlist();
    initCart(); initStickyBuy(); initBundle(); initFooterAccordions();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', measureHeader, { passive: true });
  doc.addEventListener('shopify:section:load', function () {
    normaliseHosts(); measureHeader(); initReveal(); initRails();
  });

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot);
  else boot();
})();


/* ── Vaste koopbalk op mobiel ──────────────────────────────────────────
   Verschijnt zodra de echte koopknop uit beeld is. De knop in de balk
   klikt de echte knop aan, zodat de winkelwagenlogica van het thema
   gewoon blijft werken. */
function initStickyBuy() {
  var bar = document.querySelector('[data-lh-stickybuy]');
  if (!bar) return;
  var form = document.querySelector('product-form form, form[action*="/cart/add"]');
  var real = form ? form.querySelector('button[type="submit"], [name="add"]') : null;
  if (!real) return;

  bar.hidden = false;

  function pas() {
    var r = real.getBoundingClientRect();
    var voorbij  = r.bottom < 0;                 /* knop volledig boven het beeld */
    var onderaan = (window.innerHeight + window.pageYOffset) >=
                   (document.body.scrollHeight - 40);
    bar.classList.toggle('is-in', voorbij && !onderaan);
  }

  /* Twee mechanismen naast elkaar: op sommige platforms wordt de een
     afgeknepen en de ander niet. Beide roepen dezelfde functie aan. */
  var wacht = false;
  function opScroll() {
    if (wacht) return;
    wacht = true;
    window.requestAnimationFrame(function () { wacht = false; pas(); });
  }
  window.addEventListener('scroll', opScroll, { passive: true });
  window.addEventListener('resize', opScroll, { passive: true });

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(pas, { threshold: [0, 1] }).observe(real);
  }

  pas();

  var btn = bar.querySelector('[data-lh-stickybuy-add]');
  if (btn) {
    btn.addEventListener('click', function () {
      if (real.disabled) return;
      real.click();
    });
  }
}


/* ── Footer op mobiel inklapbaar maken ─────────────────────────────────
   Het thema levert de linkgroepen als kop + lijst. Op mobiel worden dat
   <details>-blokken, zodat de footer van ~440px naar ~200px gaat. */
function initFooterAccordions() {
  if (!window.matchMedia('(max-width: 780px)').matches) return;
  var footer = document.querySelector('footer, .footer');
  if (!footer || footer.querySelector('.lh-facc')) return;

  footer.querySelectorAll('ul').forEach(function (ul) {
    if (ul.children.length < 2) return;
    // kop direct boven de lijst zoeken
    var kop = ul.previousElementSibling;
    if (!kop || !/^(H[2-6]|P|SPAN|DIV)$/.test(kop.tagName)) return;
    var titel = kop.textContent.trim();
    if (!titel || titel.length > 32) return;

    var det = document.createElement('details');
    det.className = 'lh-facc';
    var sum = document.createElement('summary');
    sum.textContent = titel;
    var body = document.createElement('div');
    body.className = 'lh-facc__body';

    kop.parentNode.insertBefore(det, kop);
    det.appendChild(sum);
    det.appendChild(body);
    body.appendChild(ul);
    kop.remove();
  });
}


/* ── Bundelkiezer: de keuze zet het aantal in het formulier ───────────── */
function initBundle() {
  var wrap = document.querySelector('[data-lh-bundle]');
  if (!wrap) return;
  var form = document.querySelector('product-form form, form[action*="/cart/add"]');
  if (!form) return;
  var qty = form.querySelector('input[name="quantity"]');

  wrap.addEventListener('change', function (e) {
    var input = e.target.closest('input[name="lh-bundle"]');
    if (!input) return;

    wrap.querySelectorAll('.lh-bundle__opt').forEach(function (o) {
      o.classList.toggle('is-active', o.contains(input));
    });

    if (qty) {
      qty.value = input.value;
      /* het thema luistert op change om zijn eigen teller bij te werken */
      qty.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      /* geen aantalveld in het formulier: er zelf een toevoegen */
      var h = form.querySelector('input[name="quantity"][data-lh-bundle-qty]');
      if (!h) {
        h = document.createElement('input');
        h.type = 'hidden'; h.name = 'quantity';
        h.setAttribute('data-lh-bundle-qty', '');
        form.appendChild(h);
      }
      h.value = input.value;
    }
  });
}

/* ── Upsell in de winkelwagenlade: toevoegen zonder herladen ─────────────
   Na /cart/add.js vuren we 'cart:refresh' af; daar luistert dit thema zelf
   op, dus de lade werkt zichzelf bij. Delegatie op document, omdat de lade
   telkens opnieuw wordt opgebouwd. */
document.addEventListener('click', async function (e) {
  var knop = e.target.closest('[data-lh-ups]');
  if (!knop) return;
  e.preventDefault();
  var id = knop.getAttribute('data-lh-ups');
  var oud = knop.innerHTML;
  knop.disabled = true; knop.textContent = 'Adding…';
  try {
    var r = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    });
    if (!r.ok) throw new Error(await r.text());
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  } catch (err) {
    knop.disabled = false; knop.innerHTML = oud;
    console.error('upsell:', err);
  }
});
